import { fromBinary } from '@bufbuild/protobuf';

import { logger } from '@gem/modules/logger';

import { buildModelError } from 'APP/model/error/errorBuilder';
import api from 'APP/restApi';
import {
  BffGetHostConfigResponseSchema,
  BffGetUnauthorizedCallHostConfigResponseSchema,
} from 'APP/wsApi/wsAppApi/types/host_config/host_config_response_pb';

import { mapHostConfigResponse, mapUnauthorizedCallHostConfigResponse } from './configModel.mapper';
import { IHostConfig } from './configModel.types';

export async function getHostConfig(): Promise<IHostConfig> {
  try {
    const result = await api.hostConfig.getHostConfig();
    const response = fromBinary(BffGetHostConfigResponseSchema, new Uint8Array(result));
    if (response.type.case !== 'success') {
      throw new Error('Error while getting host config');
    }

    return mapHostConfigResponse(response.type.value);
  } catch (error) {
    logger.get('API').error('hostConfig.getHostConfig', error);
    throw buildModelError(error);
  }
}

export const getUnauthorizedCallHostConfig = async (): Promise<IHostConfig> => {
  try {
    const result = await api.hostConfig.getUnauthorizedCallHostConfig();
    const response = fromBinary(
      BffGetUnauthorizedCallHostConfigResponseSchema,
      new Uint8Array(result)
    );

    if (response.type.case !== 'success') {
      throw new Error('Error while getting host config');
    }

    return mapUnauthorizedCallHostConfigResponse(response.type.value);
  } catch (error) {
    logger.get('API').error('tenantRouter.getDeepLinkRoutingUrls', error);
    throw buildModelError(error);
  }
};
